export const order_status_code = [
  {
    title: "Chờ xử lý",
    field_by: "order_status_code",
    field_by_value: "WAITING_FOR_PROGRESSING",
  },
  {
    title: "Đang chuẩn bị hàng",
    field_by: "order_status_code",
    field_by_value: "PACKING",
  },
  {
    title: "Hết hàng",
    field_by: "order_status_code",
    field_by_value: "OUT_OF_STOCK",
  },
  {
    title: "Shop hủy",
    field_by: "order_status_code",
    field_by_value: "USER_CANCELLED",
  },
  {
    title: "Khách đã hủy",
    field_by: "order_status_code",
    field_by_value: "CUSTOMER_CANCELLED",
  },
  {
    title: "Đang giao hàng",
    field_by: "order_status_code",
    field_by_value: "SHIPPING",
  },
  {
    title: "Lỗi giao hàng",
    field_by: "order_status_code",
    field_by_value: "DELIVERY_ERROR",
  },
  {
    title: "Đã hoàn thành",
    field_by: "order_status_code",
    field_by_value: "COMPLETED",
  },
  {
    title: "Chờ trả hàng",
    field_by: "order_status_code",
    field_by_value: "CUSTOMER_RETURNING",
  },
  {
    title: "Đã trả hàng",
    field_by: "order_status_code",
    field_by_value: "CUSTOMER_HAS_RETURNS",
  },
];
